import React from 'react'
import cn from 'classnames';
import style from './Body.module.scss'
import Cubby from '../Cubby/index';

const Body = (props) => {
    return (
        <div className={cn('row mx-0 w-100 fs_28', style.bodyContainer)}>
           <div className='col-12 p-0 h-100'>
              <Cubby {...props}/>
           </div>
        </div>
    )
}

export default Body;
